<template>
  <table class="table table-responsive">
    <thead>
      <tr>
        <th style="cursor:pointer" @click="reverseItems">
          {{ getTranslation('lbl_customer_name') }}
          <span class="arrow" :class="sortOrder > 0 ? 'asc' : 'dsc'" />
        </th>
        <th @click="reverseItems" style="cursor:pointer">
          {{ getTranslation('lbl_customer_code') }}
          <span class="arrow" :class="sortOrder > 0 ? 'asc' : 'dsc'" />
        </th>
        <th>{{ getTranslation('lbl_customer_active') }}</th>
        <th class="action" v-if="actionCol">{{ getTranslation('lbl_grid_col_action') }}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(customer, index) in filteredData" :key="customer._id">
        <td>
          <template v-if="isEdit && editIndex === index">
            <input type="text" minlength="1" v-model="customer.name">
          </template>
          <template v-else>
            <span>{{ customer.name }}</span>
          </template>
        </td>
        <td>
          <template v-if="isEdit && editIndex === index">
            <input  minlength="1" maxlength="4" type="text" v-model="customer.code">
          </template>
          <template v-else>
            <span>****</span>
          </template>
        </td>
        <td class="middle-alignment">
            <app-switch
                :autoSave="!isEdit"
                :disabled="isEdit && editIndex !== index"
                :isInList="true"
                :item="customer"
                v-model="customer.active"
                :identification="customer.name + 'active'"
            />
        </td>
        <td v-if="actionCol" style="white-space: nowrap;">
          <template v-if="editBtn && editIndex !== index">
            <button
                @click.prevent="edit(customer, index)"
                :disabled="isEdit"
                class="btn btn-default"
                :title="getTranslation('lbl_edit')"
            ><span class="glyphicon glyphicon-pencil" aria-hidden="true" /></button>
          </template>
          <template v-else-if="isEdit && editIndex === index">
            <button @click.prevent="update(customer)" class="btn btn-success"
                    :title="getTranslation('lbl_check')"><span
                class="fa fa-floppy-o" aria-hidden="true"></span></button>
            <button
                :title="getTranslation('lbl_cancel')"
                class="btn"
                @click.prevent="cancel(customer, index)"
            ><span class="fa fa-ban"></span></button>
          </template>
          <button
              v-if="deleteBtn && editIndex !== index"
              :disabled="editIndex && editIndex !== index"
              @click.prevent="remove(customer)"
              class="btn btn-danger"
          >
            <span
                :title="getTranslation('lbl_delete')"
                class="glyphicon glyphicon-trash"
                aria-hidden="true" />
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { translationMixin } from '../../../../Banet/mixins/translationMixin';
import Switch from "../../../public/components/Switch.vue";
import { mainEventBus } from '../../../../main';

export default {
  name: "CustomerTable",
  mixins: [ translationMixin ],
  components: { appSwitch: Switch },
  props: {
    data: Array,
    filterKey: String,
    actionCol: Boolean,
    saveBtn: Boolean,
    cancelBtn: Boolean,
    deleteBtn: Boolean,
    editBtn: Boolean
  },
  data() {
    return {
      codeLabel: '****',
      isEdit: false,
      editIndex: null,
      sortOrder: 1,
      preEditObj: {},
    }
  },
  sockets: {
    message: function (msg) {
      mainEventBus.$emit('alert', {type: msg.type, msg: msg.msg});
      if(msg.type === 'error') {
          this.reset();
          this.isEdit = true;
          this.editIndex = this.preEditObj.ind;
      }
    },
  },
  methods: {
    displayCode(ind, v) {
        console.log('ENTER: ', this.showCode, ind, v);
        this.showCode[ind] = v;
    },
    update: function(data) {
      this.$emit('update', data);
      this.isEdit = false;
      this.editIndex = null;
    },
    cancel: function(data, index) {
        this.reset(true);
        this.$emit('cancel', data);
        this.isEdit = false;
        this.editIndex = null;
    },
    reset(full) {
        this.filteredData[this.preEditObj.ind].name = this.preEditObj.name;
        this.filteredData[this.preEditObj.ind].code = this.preEditObj.code;
        this.filteredData[this.preEditObj.ind].active = this.preEditObj.active;
        if(full) { this.preEditObj = {}; }
    },
    remove: function(data) { this.$emit('delete', data); },
    edit(data, index) {
      this.preEditObj = { ...data };
      this.preEditObj.ind = index;
      this.$emit('edit', index, data);
      this.isEdit = true;
      this.editIndex = index;
    },
    reverseItems() {
      this.filteredData = this.filteredData.sort(() => {
        this.sortOrder *= -1;
        return this.sortOrder * -1;
      });
    }
  },
  computed: {
    filteredData: {
      get: function() {
        let grid = [];
        for (const customer of this.data)
          if (customer._id) grid.push(customer);
        if (this.filterKey.length <= 0) {
          return grid;
        } else
          return grid.filter(
              item => item.name.toLowerCase().includes(this.filterKey.toLowerCase()) ||
                  item.code.toLowerCase().includes(this.filterKey.toLowerCase())
          )
      },
      set: function(_) { this.data = _; }
    }
  },
}
</script>

<style scoped>
.action { width: 5px; }
.middle-alignment { display: flex; align-items: center; justify-content: flex-start; }
</style>


// WEBPACK FOOTER //
// CustomerTable.vue?5e42d038